<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >

            <rkm-area
                title="Laboratório"
                type="fieldset"
            >
                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="laboratorios"
                            :validations="validations.unidade"
                            label="Laboratório"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            :disabled="isReadOnly ? true : false"
                            value-field="unidadeId"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="infraestruturas"
                            :validations="validations.infraestrutura"
                            textField="nome"
                            v-model="model.infraestruturaId"
                            :disabled="isReadOnly ? true : false"
                            valueField="id"
                            show-default-option
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row class="flex-nowrap">

                    <rkm-col class="flex-grow-1">
                        <rkm-form-select
                            :options="data.form.tipo"
                            label="Tipo"
                            :validations="validations.tipo"
                            :disabled="isReadOnly ? true : false"
                            show-default-option
                            text-field="descricao"
                            v-model="model.cotaTipoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            v-model="model.periodo"
                            :min-date="minDate"
                            :max-date="maxDate"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-row>

                <rkm-col
                    cols="12"
                >
                    <rkm-area
                        :title="checkHandleAlter ? 'Alterar cota' : 'Cadastrar cota'"
                        type="fieldset"
                    >

                        <rkm-row class="flex-nowrap">

                            <rkm-col cols="7">
                                <rkm-form-select
                                    :options="data.form.exames"
                                    :validations="validations.exame"
                                    label="Exame"
                                    show-default-option
                                    text-field="nome"
                                    v-model="model.exameId"
                                    value-field="id"
                                />
                            </rkm-col>

                            <rkm-col class="flex-grow-1" v-show="model.cotaTipoId == enums.tipoCota.QUANTIDADE">
                                <rkm-form-input
                                    label="Cota"
                                    v-model="model.cotaQuantidade"
                                    :validations="model.cotaTipoId == enums.tipoCota.QUANTIDADE ? validations.cotaQuantidade : {}"
                                    number
                                />
                            </rkm-col>

                            <rkm-col class="flex-grow-1" v-show="model.cotaTipoId != enums.tipoCota.QUANTIDADE">
                                <rkm-form-input
                                    label="Cota"
                                    ref="cotaValor"
                                    v-model="model.cotaValor"
                                    :validations="model.cotaTipoId == enums.tipoCota.VALOR ? validations.cotaValor : {}"
                                    v-money="money"
                                    prepend="R$"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>

                            <rkm-col cols="12">
                                <rkm-form-textarea
                                    label="Observação"
                                    v-model="model.observacao"
                                    name="observacao"
                                    rows="2"
                                    max-rows="2"
                                    :validations="validations.observacao"
                                    class="mb-0"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>

                                <rkm-button
                                    :label="false"
                                    color="primary"
                                    @click.stop="handleCota({exameId: model.exameId}, 'add')"
                                    class="mt-0 float-right"
                                >
                                    {{ checkHandleAlter ? 'Alterar' : 'Incluir' }}
                                </rkm-button>

                                <rkm-button
                                    v-if="checkHandleAlter"
                                    :label="false"
                                    color="secondary"
                                    @click.stop="hideAlter()"
                                    class="mt-0 mr-2 float-right"
                                >
                                    Voltar
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <rkm-area
                        title="Cotas cadastradas"
                        v-if="!checkHandleAlter"
                    >

                        <rkm-row>
                            <rkm-col>

                                <rkm-table
                                    :items="model.exames"
                                    :fields="fields.tables.tipo"
                                    sort-by="exameNome"
                                    class="mt-3"
                                >

                                    <template v-slot:cell(cota)="{ item }">
                                        {{ formatQuantidade(item) }}
                                    </template>

                                    <template v-slot:cell(distribuida)="row">
                                        {{ handleCotaAtribuida(row.item) }}
                                    </template>

                                    <template v-slot:cell(utilizada)="row">
                                        {{ getUtilizada(row.item) }}
                                    </template>

                                    <template v-slot:cell(saldo)="row">
                                        {{ getSaldo(row.item) }}
                                    </template>

                                    <template v-slot:cell(aDistribuir)="row">
                                        {{ getCotaADistribuir(row.item) }}
                                    </template>

                                    <template v-slot:cell(actions)="{ item }">

                                        <rkm-button
                                            :color="item.observacao ? 'info' : 'secondary'"
                                            small
                                            v-rkm-popover.hover.left="{
                                                title:'Observação',
                                                html:true,
                                                content: item.observacao ? item.observacao : 'Nenhuma observação informada.',
                                                }"
                                        >
                                            <i class="fas fa-comment-alt"></i>
                                        </rkm-button>

                                        <rkm-button
                                            @click.stop="handleAlter(item)"
                                            color="primary"
                                            small
                                            title="Editar"
                                        >
                                            <rkm-icon icon="pen" />
                                        </rkm-button>

                                        <rkm-button
                                            @click="handleCota(item, 'handleDestroy')"
                                            color="danger"
                                            small
                                            title="Excluir"
                                        >
                                            <rkm-icon icon="trash" />
                                        </rkm-button>
                                    </template>
                                </rkm-table>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, object, data, formats } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import tipoCota from '@/enums/exame-laboratorial/tipoCota'

//Directives
import { VMoney } from 'v-money'

export default {
    directives: { money: VMoney },
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
                exame: { required: true },
                tipo: { required: true },
                cotaValor: { max: 13, min_value: 0.01 },
                cotaQuantidade: { min_value: 1, required: true  },
                observacao: { max: 500 },
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
            }
        },
        periodoInalterado() {

            if (!this.periodoOriginal.start || !this.periodoOriginal.end) {

                return false
            }

            return this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY') === this.periodoOriginal.start
                && this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY') === this.periodoOriginal.end
        },
        maxDate() {

            if (this.periodoInalterado) {

                return null
            }

            if (this.model.periodo.start) {

                return moment(this.getFormatedDate(this.model.periodo.start, 'YYYY-MM-DD')).endOf('month').format('DD-MM-YYYY')
            }

            return null
        },
        minDate() {

            if (this.periodoInalterado) {

                return null
            }

            if (this.model.periodo.end) {

                return moment(this.getFormatedDate(this.model.periodo.end, 'YYYY-MM-DD')).startOf('month').format('DD-MM-YYYY')
            }

            return null
        },
        hasIndex() {

            return this.index !== null
        },
        infraestruturas() {

            if (this.model.unidadeId) {

                let infraestruturaPrincipal = this.laboratorioParametrizado.find(u =>
                    u.unidadeId === this.model.unidadeId).infraestruturas

                if (!this.isReadOnly) {

                    this.getPrincipal(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal
            }

            return []
        },
        laboratorios() {

            const unidades = []

            this.data.model.unidades.filter(u => u.laboratorio).map(unidade => {

                const unidadeInserida = unidades.find(u => u.unidadeId === unidade.unidadeId)

                if (unidadeInserida) {

                    unidadeInserida.infraestruturas.push({

                        id: unidade.infraestruturaId,
                        nome: unidade.infraestruturaNome,
                        principal: unidade.infraestruturaPrincipal,
                    })

                } else {

                    unidades.push({

                        unidadeId: unidade.unidadeId,
                        nomeFantasia: unidade.nomeFantasia,
                        infraestruturas: [
                            {
                                id: unidade.infraestruturaId,
                                nome: unidade.infraestruturaNome,
                                principal: unidade.infraestruturaPrincipal,
                            }
                        ]
                    })
                }
            })

            this.getUnidade(unidades)

            return unidades
        },
        fields() {

            return {
                tables: {
                    tipo: [
                        { key: 'exameNome', label: 'Exame', sortable: true },
                        { key: 'cota', label: 'Cota', sortable: true },
                        { key: 'distribuida', label: 'Distribuída', sortable: true },
                        { key: 'aDistribuir', label: 'A distribuir', sortable: true },
                        { key: 'utilizada', label: 'Utilizada', sortable: true },
                        { key: 'saldo', label: 'Saldo', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        },
    },
    created() {

        this.repositories = {
            saldo: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }

        this.load()
    },
    data: () => ({
        form: {
            exames: {},
        },
        model: {
            id: null,
            itemId: null,
            exames: [],
            exameId: null,
            exameDisabled: false,
            cota: null,
            cotaTipoNome: null,
            cotaTipoId: null,
            cotaValor: null,
            cotaQuantidade: '',
            unidadeId: null,
            infraestruturaId: null,
            valorUtilizado: '0',
            quantidadeUtilizada: '0',
            periodo: {
                start: null,
                end: null
            },
            observacao: null,
        },
        periodoOriginal: {
            start: null,
            end: null,
        },
        checkHandleAlter: false,
        enums: {
            tipoCota
        },
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
        isReadOnly: false,
        cotasAtribuidas: 0,
        utilizada: 0,
        utilizadas: 0,
        saldoUtilizadas: 0,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.hasIndex) {

                const objId = this.data.model.cotasExamePeriodo.findIndex((obj => obj.id == this.item.id));

                const data = this.data.model.cotasExamePeriodo[objId]

                this.model.id = data.id
                this.model.exames = data.exames

                this.model.cotaTipoId = data.cotaTipoId
                this.model.infraestruturaId = data.infraestruturaId
                this.model.unidadeId = data.unidadeId
                this.model.periodo.start = moment(data.periodo.start,'DD/MM/YYYY').toDate()
                this.model.periodo.end = moment(data.periodo.end,'DD/MM/YYYY').toDate()

                this.periodoOriginal = {
                    start: data.periodo.start,
                    end: data.periodo.end,
                }

                this.isReadOnly = true
            }
        },
        getUnidade(unidades) {
            this.laboratorioParametrizado = unidades
        },
        getPrincipal(infraestruturaPrincipal) {
            this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
        },
        save() {

            if (this.hasUnidadeParametrizada()) {

                this.showValidationNotification(
                    "Já existe um registro para a unidade, o local de atendimento, o tipo e "
                        + "entre o período selecionado."
                )

                return false
            }

            if (!this.model.unidadeId || !this.model.infraestruturaId) {

                this.showValidationNotification("Necessário informar a unidade e o local de atendimento")

                return false
            }

            if (!this.model.cotaTipoId) {

                this.showValidationNotification("Necessário informar o tipo da cota.")

                return false
            }

            if (!this.model.periodo.start || !this.model.periodo.end) {

                this.showValidationNotification("Necessário informar o período inicial e final.")

                return false
            }

            if (this.model.exames.length == 0) {

                this.showValidationNotification("Necessário cadastrar ao menos uma cota e exame.")

                return false
            }

            this.model.periodo.start = this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY')
            this.model.periodo.end = this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY')
            this.model.cotaValor = this.model.cotaValor.replace('R$ ', '')

            this.model.unidade = this.data.form.unidades
                .find(s => s.id === this.model.unidadeId).nomeFantasia

            this.model.infraestrutura = this.infraestruturas
                .find(s => s.id === this.model.infraestruturaId).nome

            if (this.model.cotaTipoId == this.enums.tipoCota.VALOR) {
                this.model.cotaTipoNome = 'Valor'
                this.model.cota = this.model.cotaValor
            } else {
                this.model.cotaTipoNome = 'Quantidade'
                this.model.cota = this.model.cotaQuantidade
            }

            if (this.index == null) {

                this.model.id = this.uniqueId(`e-${this.model.unidadeId}${
                    this.model.infraestruturaId}${this.model.cotaTipoId}${this.model.exameId}${
                    this.getFormatedDate(this.model.periodo.start, 'DDMMYYYY')}`)
            }

            const param = {
                id: this.model.id,
                cotaTipoId: this.model.cotaTipoId,
                cotaNome: this.model.cotaTipoNome,
                observacao: this.model.observacao,
                periodo: this.model.periodo,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                unidade: this.model.unidade,
                infraestrutura: this.model.infraestrutura,
                exames: this.model.exames,
                alterado: true,
            }

            if (this.index !== null) {

                const objIndex = this.data.model.cotasExamePeriodo.findIndex((obj => obj.id == this.model.id));

                this.$set(this.data.model.cotasExamePeriodo, objIndex, this.clone(param))
            }
            else {

                this.data.model.cotasExamePeriodo.push(this.clone(param))
            }

            this.$emit('save', this.clone(param))
        },
        add() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                        if (!this.checkHandleAlter
                            && this.model.exames.find((obj => obj.exameId == this.model.exameId))) {

                                this.showValidationNotification(
                                    "Exame já cadastrado anteriormente nesta cota."
                                )

                            return false
                        }

                        if (this.model.cotaTipoId == this.enums.tipoCota.VALOR) {

                            this.model.cota = this.model.cotaValor
                        } else {

                            this.model.cota = this.model.cotaQuantidade
                        }

                        let periodo = this.model.periodo
                        periodo.start = this.getFormatedDate(periodo.start, 'YYYY-MM-DD')
                        periodo.end = this.getFormatedDate(periodo.end, 'YYYY-MM-DD')

                        const obj = this.model.exames.findIndex((obj => obj.exameId == this.model.exameId));

                        if (obj <= 0) {

                        this.model.itemId = this.uniqueId(`e-${this.model.unidadeId}${
                            this.model.infraestruturaId}${this.model.cotaTipoId}${this.model.exameId}${
                            this.getFormatedDate(this.model.periodo.start, 'DDMMYYYY')}`)
                        }

                        const exameNome = this.data.form.exames.find(s => s.id === this.model.exameId).nome
                        const unidadeNome = this.laboratorios.find(s => s.unidadeId === this.model.unidadeId).nomeFantasia
                        const infraestruturaNome = this.infraestruturas.find(s => s.id === this.model.infraestruturaId).nome

                        const paramExame = {
                            id: this.model.itemId,
                            exameId: this.model.exameId,
                            exameNome: exameNome,
                            cotaQuantidade: this.model.cotaQuantidade ? this.model.cotaQuantidade : 0,
                            cotaValor: this.model.cotaValor,
                            cota: this.model.cota,
                            cotaTipoId: this.model.cotaTipoId,
                            cotaNome: this.model.cotaTipoNome,
                            observacao: this.model.observacao,
                            periodo: periodo,
                            unidadeId: this.model.unidadeId,
                            infraestruturaId: this.model.infraestruturaId,
                            unidade: unidadeNome,
                            infraestrutura: infraestruturaNome,
                            valorUtilizado: this.model.valorUtilizado,
                            quantidadeUtilizada: this.model.quantidadeUtilizada
                        }

                        if (obj >= 0) {

                            if (this.model.cotaTipoId == this.enums.tipoCota.VALOR) {

                                let cotaValor = this.model.cota.replace('.','').replace(',','.')
                                let cotasAtribuidas = this.cotasAtribuidas.replace('.','').replace(',','.')
                                let utilizadas = this.utilizadas.replace('.','').replace(',','.')

                                if (parseFloat(cotasAtribuidas) > parseFloat(cotaValor)) {

                                    this.showValidationNotification(`A cota é menor que a cota atribuída
                                        para o exame <strong>(${exameNome})</strong> em (Parametrização > Cotas
                                        > Laboratório > Exames), para o laboratório <strong>${unidadeNome}</strong> e o
                                        local de atendimento <strong>${infraestruturaNome}</strong> no período de
                                        <strong>${this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY')}</strong> até
                                        <strong>${this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY')}</strong>.
                                        A cota deve ser maior ou igual a <strong>R$ ${this.cotasAtribuidas}</strong>.
                                        `)

                                    return false
                                }

                                if (parseFloat(utilizadas) > parseFloat(cotaValor)) {

                                    this.showValidationNotification(`A cota é menor que a soma dos exames
                                        <strong>(${exameNome})</strong> agendados para o laboratório
                                        <strong>${unidadeNome}</strong> e o local de
                                        atendimento <strong>${infraestruturaNome}</strong> no período de
                                        <strong>${this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY')} até
                                        ${this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY')}</strong>.
                                        A cota deve ser maior ou igual a <strong>R$ ${this.utilizadas}</strong>.
                                        `)

                                    return false
                                }

                            } else {

                                if (parseFloat(this.cotasAtribuidas.replace('.','')) > this.model.cota) {

                                    this.showValidationNotification(`A cota é menor que a cota atribuída
                                        para o exame <strong>(${exameNome})</strong> em (Parametrização > Cotas
                                        > Laboratório > Exames), para o laboratório <strong>${unidadeNome}</strong> e o
                                        local de atendimento <strong>${infraestruturaNome}</strong> no período de
                                        <strong>${this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY')}</strong> até
                                        <strong>${this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY')}</strong>.
                                        A cota deve ser maior ou igual a <strong>${this.cotasAtribuidas}</strong>.
                                        `)

                                    return false
                                }

                                if (parseFloat(this.utilizadas) > parseFloat(this.model.cota)) {

                                    this.showValidationNotification(`A cota é menor que a soma dos exames
                                        <strong>(${exameNome})</strong> agendados para o laboratório
                                        <strong>${unidadeNome}</strong> e o local de
                                        atendimento <strong>${infraestruturaNome}</strong> no período de
                                        <strong>${this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY')} até
                                        ${this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY')}</strong>.
                                        A cota deve ser maior ou igual a <strong>${this.utilizadas}</strong>.
                                        `)

                                    return false
                                }
                            }

                            this.$set(this.model.exames, obj, this.clone(paramExame))
                        } else {

                            this.model.exames.push(this.clone(paramExame))
                        }

                        this.hideAlter()
                })
        },
        handleCota(item, acao) {

            this.setLoading()

            const data = this.model

            this.repositories.saldo.saldoExame({
                unidade_id: this.model.unidadeId,
                infraestrutura_id: this.model.infraestruturaId,
                exame_id: item.exameId,
                inicio: this.getFormatedDate(this.model.periodo.start, 'YYYY-MM-DD'),
                fim: this.getFormatedDate(this.model.periodo.end, 'YYYY-MM-DD'),
            })
                .then(response => {

                    if (acao == 'add') {

                        if (this.model.cotaTipoId == this.enums.tipoCota.VALOR) {

                            this.model.cota = this.model.cotaValor
                        } else {

                            this.model.cota = this.model.cotaQuantidade
                        }

                        item.cota = this.model.cota

                        this.getCotaAtribuida(data, response.data, item)

                        this.$refs.Form.validate(this.add)
                    }  else if (acao == 'handleDestroy') {

                        this.getCotaAtribuida(data, response.data, item)
                        this.handleDestroy(item)
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        hasUnidadeParametrizada() {

            return this.data.model.cotasExamePeriodo.find(cc => cc.id !== this.model.id
                && cc.unidadeId == this.model.unidadeId
                && cc.infraestruturaId == this.model.infraestruturaId
                && cc.cotaTipoId == this.model.cotaTipoId
                && moment(
                        this.getFormatedDate(this.model.periodo.start, 'YYYY-MM-DD')
                    )
                    .isBetween(
                        cc.periodo.start.split("/").reverse().join("-"),
                        cc.periodo.end.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )

                || cc.id !== this.model.id
                    && cc.unidadeId == this.model.unidadeId
                    && cc.infraestruturaId == this.model.infraestruturaId
                    && cc.cotaTipoId == this.model.cotaTipoId
                    && moment(
                            this.getFormatedDate(this.model.periodo.end, 'YYYY-MM-DD')
                        )
                        .isBetween(
                            cc.periodo.start.split("/").reverse().join("-"),
                            cc.periodo.end.split("/").reverse().join("-"),
                            null,
                            '[]'
                        )

                || cc.id !== this.model.id
                    && cc.unidadeId == this.model.unidadeId
                    && cc.infraestruturaId == this.model.infraestruturaId
                    && cc.cotaTipoId == this.model.cotaTipoId
                    && moment(
                            this.getFormatedDate(this.model.periodo.start, 'YYYY-MM-DD')
                        )
                        .isBefore(
                            cc.periodo.start.split("/").reverse().join("-"),
                        )
                    && moment(this.getFormatedDate(this.model.periodo.end, 'YYYY-MM-DD'))
                        .isAfter(
                            cc.periodo.end.split("/").reverse().join("-"),
                        )
                )
        },
        getUtilizada(item) {

            if (item.cotaTipoId == this.enums.tipoCota.VALOR) {

                let valorUtilizado = this.formatSumMoney(item.valorUtilizado)

                return this.formatMoney(parseFloat(valorUtilizado), 2)
            } else {

                let quantidadeUtilizada = this.formatMoney(item.quantidadeUtilizada, 0)
                quantidadeUtilizada = this.formatSumMoney(quantidadeUtilizada)

                return this.formatMoney(parseFloat(quantidadeUtilizada), 0)
            }
        },
        getSaldo(item) {

            if (item.cotaTipoId == this.enums.tipoCota.VALOR) {

                let cota = this.formatMoney(item.cota, 2)
                let valorUtilizado = this.formatSumMoney(item.valorUtilizado)

                const saldo = this.formatSumMoney(cota) - valorUtilizado

                return this.formatMoney(parseFloat(saldo), 2)
            } else {

                return  this.formatMoney(item.cota - Number(item.quantidadeUtilizada), 0)
            }
        },
        getCotaADistribuir(item) {

            let cotasAtribuidas = 0

            if (item.cotaTipoId == this.enums.tipoCota.VALOR) {

                let cota = this.formatMoney(item.cota, 2)
                cotasAtribuidas = this.handleCotaAtribuida(item)

                let saldoAtribuidas = this.formatSumMoney(cota) - this.formatSumMoney(cotasAtribuidas)
                return this.formatMoney(saldoAtribuidas, 2)
            } else {

                let cota = this.formatMoney(item.cota, 0)
                cotasAtribuidas = this.handleCotaAtribuida(item)

                let saldoAtribuidas = this.formatSumMoney(cota) - this.formatSumMoney(cotasAtribuidas)
                return this.formatMoney(saldoAtribuidas, 0)
            }
        },
        getCotaAtribuida(cotaExamePeriodo, items, item) {

            this.cotasAtribuidas = 0
            this.cotaAtribuida = 0

            const cota = items.cotasLaboratorio.find((unidade) => unidade.unidadeId == cotaExamePeriodo.unidadeId
                && unidade.infraestruturaId == cotaExamePeriodo.infraestruturaId)

            if (cota) {

                cota.cotaLaboratorio.filter(field => field.cotaTipoId == cotaExamePeriodo.cotaTipoId
                    && moment(
                        field.periodo.start.split("/").reverse().join("-")
                    )
                    .isBetween(
                        this.getFormatedDate(this.model.periodo.start, 'YYYY-MM-DD'),
                        this.getFormatedDate(this.model.periodo.end, 'YYYY-MM-DD'),
                        null,
                        '[]'
                    )
                    && moment(
                        field.periodo.end.split("/").reverse().join("-")
                    )
                    .isBetween(
                        this.getFormatedDate(this.model.periodo.start, 'YYYY-MM-DD'),
                        this.getFormatedDate(this.model.periodo.end, 'YYYY-MM-DD'),
                        null,
                        '[]'
                    )
                ).map(exame => {

                    this.cotaAtribuida = exame.exames.filter(field => field.exameId == cotaExamePeriodo.exameId)
                        .reduce((sum, element) => {

                            if (cotaExamePeriodo.cotaTipoId == this.enums.tipoCota.VALOR) {

                                if (element.cota) {

                                    sum = sum + this.formatSumMoney(element.cota);
                                }
                            } else {

                                if (element.cota) {

                                    sum = Number(sum) + Number(element.cota);
                                }
                            }

                            return sum
                        },0)

                    this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                })
            }

            if (cotaExamePeriodo.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.cotasAtribuidas = this.formatMoney(this.cotasAtribuidas, 2)
                this.saldoAtribuidas = this.formatSumMoney(item.cota) - this.formatSumMoney(this.cotasAtribuidas)
                this.saldoAtribuidas = this.formatMoney(this.saldoAtribuidas, 2)
                let valorAgendado = this.formatMoney(parseFloat(items.valorAgendado), 2)

                if (this.cotasAtribuidas > 0 || this.cotasAtribuidas > '0,00') {

                    this.saldoUtilizadas = this.formatSumMoney(this.cotasAtribuidas) - this.formatSumMoney(valorAgendado)
                    this.saldoUtilizadas = this.formatMoney(this.saldoUtilizadas, 2)
                    this.utilizadas = this.formatMoney(parseFloat(items.valorAgendado), 2)
                } else {

                    this.saldoUtilizadas = this.formatMoney(this.saldoUtilizadas, 2)
                    this.utilizadas = this.formatMoney(parseFloat(items.valorAgendado), 2)
                }
            } else {

                this.saldoAtribuidas = item.cota - Number(this.cotasAtribuidas)
                this.saldoAtribuidas = this.formatMoney(this.saldoAtribuidas, 0)
                this.cotasAtribuidas = this.formatMoney(this.cotasAtribuidas, 0)

                this.utilizadas = items.quantidadeAgendada

                if (this.cotasAtribuidas > 0) {

                    this.saldoUtilizadas = this.cotasAtribuidas - Number(this.utilizadas)
                    this.saldoUtilizadas = this.formatMoney(this.saldoUtilizadas, 0)
                }
            }
        },
        handleAlter(item) {

            this.model.itemId = item.id
            this.model.cotaQuantidade = item.cotaQuantidade
            this.model.observacao = item.observacao
            this.model.cotaValor = item.cotaValor
            this.model.exameId = item.exameId
            this.model.valorUtilizado = item.valorUtilizado
            this.model.quantidadeUtilizada = item.quantidadeUtilizada
            this.$refs.cotaValor.$el.getElementsByTagName('input')[0].value = item.cotaValor;

            if (this.model.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.cotaOld = item.cotaValor
            } else {

                this.cotaOld = item.cotaQuantidade
            }

            this.checkHandleAlter = true
            this.$emit('checkHandleAlter', true)
        },
        hideAlter() {

            this.checkHandleAlter = false

            this.$emit('checkHandleAlter', false)
            this.resetForm()
        },
        resetForm() {

            this.model.exameId = null
            this.model.observacao = ''
            this.model.cotaQuantidade = ''
            this.model.cotaValor = null

            this.$refs.cotaValor.$el.getElementsByTagName('input')[0].value = 0;

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        handleDestroy(item) {

            if (this.utilizadas == 0 || this.utilizadas == '0,00') {

                if (this.cotasAtribuidas > 0 || this.cotasAtribuidas > "0,00") {

                    this.showValidationNotification(`Não é possível excluir o exame <strong>${ item.exameNome }</strong>,
                        pois já possui cotas atribuídas.`)

                    return false
                }

                const objId = this.model.exames.findIndex((obj => obj.id == item.id));

                const destroy = async () => this.model.exames.splice(objId, 1)

                this.showDeleteConfirmation(`Deseja realmente excluir a cota do exame
                <strong>${ item.exameNome }</strong>?`, destroy)

            } else {

                this.showValidationNotification(`Não é possível excluir o exame <strong>${ item.exameNome }</strong>, pois
                    já possui agendamento(s) vinculado(s) a ele.`)

                return false
            }
        },
        handleCotaAtribuida(item) {

            let cotasAtribuidas = 0
            let cotaAtribuida = 0

            const cota = this.data.model.cotasLaboratorio.find((unidade) => unidade.unidadeId == item.unidadeId
                && unidade.infraestruturaId == item.infraestruturaId)

            if (cota) {

                cota.cotaLaboratorio.filter(field => field.cotaTipoId == item.cotaTipoId
                    && moment(
                        field.periodo.start.split("/").reverse().join("-")
                    )
                    .isBetween(
                        item.periodo.start.split("/").reverse().join("-"),
                        item.periodo.end.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
                    && moment(
                        field.periodo.end.split("/").reverse().join("-")
                    )
                    .isBetween(
                        item.periodo.start.split("/").reverse().join("-"),
                        item.periodo.end.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
                ).map(exame => {

                    cotaAtribuida = exame.exames.filter(field => field.exameId == item.exameId)
                        .reduce((sum, element) => {

                            if (item.cotaTipoId == this.enums.tipoCota.VALOR) {

                                if (element.cota) {

                                    sum = sum + this.formatSumMoney(element.cota);
                                }
                            } else {

                                if (element.cota) {

                                    sum = Number(sum) + Number(element.cota);
                                }
                            }

                            return sum
                        },0)

                    cotasAtribuidas = cotasAtribuidas + cotaAtribuida
                })
            }

            if (item.cotaTipoId == this.enums.tipoCota.VALOR) {

                return this.formatMoney(cotasAtribuidas, 2)
            } else {

                return this.formatMoney(cotasAtribuidas, 0)
            }
        },
        formatQuantidade(item) {

            const cota = item.cota
            return item.cotaTipoId == this.enums.tipoCota.VALOR ? cota : this.formatMoney(Number(cota), 0)
        },
    },
    mixins: [repository, object, data, formats],
    props: {
        data: { type: Object, required: true },
        index: { type: Number, default: null },
        item: { type: Object, default: null },
    },
}
</script>